import React from 'react';
import { useGlobalState } from '../../store/state';
import InfluencerTopSubHeaderComponent from '../../components/Influencers/Common/InfluencerTopSubHeaderComponent';
import InfluencerBaseLayoutComponent from '../../components/Layout/Influencer/InfluencerBaseLayoutComponent';
import ProfileWidget from '../../components/Influencers/Profile/ProfileWidget';

export const InfluencerProfilePage = () => {
  const [user] = useGlobalState('user');

  return (
    <InfluencerBaseLayoutComponent>
      <InfluencerTopSubHeaderComponent className="px-3 py-2 sticky">
                Hello <strong>{`${user.firstname} ${user.lastname}`}</strong>
        <p className="m-0"
          style={{ fontSize: '0.8rem' }}>Update Your profile</p>
      </InfluencerTopSubHeaderComponent>
      <div>
        <ProfileWidget/>
      </div>
    </InfluencerBaseLayoutComponent>
  );
};
